"use strict";

import "./../../lib/chosen-js/chosen.jquery";

(function($) {
    function init() {
        function handleLocationError(browserHasGeolocation, infoWindow, pos) {
            infoWindow.setPosition(pos);
            infoWindow.setContent(
                browserHasGeolocation
                    ? "Error: The Geolocation service failed."
                    : "Error: Your browser doesn't support geolocation."
            );
            infoWindow.open(map);
        }

        function find_me_on_map() {
            navigator.geolocation.getCurrentPosition(
                position => {
                    const pos = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    };

                    let marker = new google.maps.Marker({
                        map: myMap,
                        position: pos,
                        clickable: false
                    });
                    marker.setIcon("/assets/img/marker_location.png");

                    myMap.setCenter(pos);
                    myMap.setZoom(16);
                },
                () => {
                    handleLocationError(true, info_window, myMap.getCenter());
                }
            );
            // navigator.geolocation.getCurrentPosition(function (location) {
            //     myMap.setCenter({lat: location.coords.latitude, lng: location.coords.longitude});
            //     myMap.setZoom(16);
            // });
        }

        $(".find_me").on("click", function(e) {
            // e.preventDefault();
            find_me_on_map();
        });

        $(".store-item__link").on("click", function(event) {
            event.preventDefault();
            $('.outlets__switch-btn[data-toggle-page="map"]').trigger("click");

            const region_points = [];
            const brandChoosenCollection = $("#js-select-brands").data("value");
            const cityFilter = $("#city").val();
            for (i in points) {
                if (cityFilter !== "all") {
                    if (points[i]["city"] === Number(cityFilter)) {
                        if (brandChoosenCollection.length) {
                            if (
                                brandChoosenCollection.some(function(brand) {
                                    return (
                                        points[i]["brand_name"].indexOf(
                                            brand
                                        ) >= 0
                                    );
                                })
                            ) {
                                region_points.push(points[i]);
                            }
                        } else {
                            region_points.push(points[i]);
                        }
                    }
                } else if (brandChoosenCollection.length) {
                    if (
                        brandChoosenCollection.some(function(brand) {
                            return points[i]["brand_name"].indexOf(brand) >= 0;
                        })
                    ) {
                        region_points.push(points[i]);
                    }
                } else {
                    region_points.push(points[i]);
                }
            }
            //set_points(region_points);
            zoom_to_marker($(this).data("id"), true, region_points);
        });

        $('input[name="market_type"]').on("click", function() {
            var new_points = [];
            if ($(this).val() == "market_loyalty") {
                for (i in points) {
                    if (points[i]["is_lp"] == "1") {
                        new_points.push(points[i]);
                    }
                }
            } else {
                new_points = region_points;
            }
            set_points(new_points);
            markerCluster = new MarkerClusterer(myMap, allMarkers, {
                gridSize: 30,
                maxZoom: 8,
                styles: [cluster_options]
            });
        });

        var city = document.getElementById("city");
        var filter_prams = {
            disable_search: false,
            width: "250px",
            no_results_text: "Не знайдено"
        };

        if (!city) {
            return;
        }

        $("#region").chosen(filter_prams);

        $(document).on("js-select-brands-changed", function() {
            // Map filter
            $(".outlets__loader").show();
            region_points = [];
            const brandChoosenCollection = $("#js-select-brands").data("value");
            const cityFilter = $("#city").val();
            for (i in points) {
                if (cityFilter !== "all") {
                    if (points[i]["city"] === Number(cityFilter)) {
                        if (brandChoosenCollection.length) {
                            if (
                                brandChoosenCollection.some(function(brand) {
                                    return (
                                        points[i]["brand_name"].indexOf(
                                            brand
                                        ) >= 0
                                    );
                                })
                            ) {
                                region_points.push(points[i]);
                            }
                        } else {
                            region_points.push(points[i]);
                        }
                    }
                } else if (brandChoosenCollection.length) {
                    if (
                        brandChoosenCollection.some(function(brand) {
                            return points[i]["brand_name"].indexOf(brand) >= 0;
                        })
                    ) {
                        region_points.push(points[i]);
                    }
                } else {
                    region_points.push(points[i]);
                }
            }
            set_points(region_points);
            markerCluster = new MarkerClusterer(myMap, allMarkers, {
                gridSize: 30,
                maxZoom: 8,
                styles: [cluster_options]
            });
            $(
                ".container-map-list .region-title, .container-map-list .city-title, .container-map-list .store-list"
            ).hide();
            $(".city_" + $(this).val()).show();

            // List cities

            const cityListControls = $("button[item-to-filter]");
            cityListControls.each(function() {
                $(this)
                    .parents("li")
                    .removeClass("hide--brands");
                $(this)
                    .parents("li")
                    .show();

                const _brands = $(this).data("brands");
                if (brandChoosenCollection.length) {
                    if (
                        brandChoosenCollection.some(function(brand) {
                            return _brands.indexOf(brand) >= 0;
                        })
                    ) {
                        $(this)
                            .parents("li")
                            .removeClass("hide--brands");
                        $(this)
                            .parents("li")
                            .show();
                    } else {
                        $(this)
                            .parents("li")
                            .addClass("hide--brands");
                        $(this)
                            .parents("li")
                            .hide();
                    }
                } else {
                    $(this)
                        .parents("li")
                        .removeClass("hide--brands");
                    $(this)
                        .parents("li")
                        .show();
                }
            });

            // List shops

            setTimeout(() => {
                const shopListBlocks = $(".outlets__list-location-item");
                shopListBlocks.each(function() {
                    $(this).removeClass("hide--brands");

                    const _brand = $(this).data("brand");
                    if (brandChoosenCollection.length) {
                        if (
                            brandChoosenCollection.some(function(brand) {
                                return _brand.indexOf(brand) >= 0;
                            })
                        ) {
                            $(this).removeClass("hide--brands");
                        } else {
                            $(this).addClass("hide--brands");
                        }
                    } else {
                        $(this).removeClass("hide--brands");
                    }
                });

                // Count shops

                if (shopListBlocks.length) {
                    cityListControls.each(function() {
                        let count = 0;
                        const id = $(this).data("locality_id");

                        shopListBlocks.each(function() {
                            const shop_city_id = $(this).data("city-id");

                            if (shop_city_id === id) {
                                if (!$(this).hasClass("hide--brands")) {
                                    count++;
                                }
                            }
                        });

                        $(this)
                            .children(".item-to-filter-count")
                            .text(count);
                        if (count === 0) {
                            $(this).hide();
                            $(this)
                                .parents("li")
                                .hide();
                            $(
                                ".outlets__list-right[data-locality_id=" +
                                    id +
                                    "]"
                            ).hide();
                            $(this)
                                .parents("li")
                                .addClass("hide--brands");
                        } else {
                            $(this).show();
                            $(this)
                                .parents("li")
                                .show();
                            $(this)
                                .parents("li")
                                .removeClass("hide--brands");
                            $(this)
                                .children(".item-to-filter-count")
                                .text(count);
                        }
                    });
                }

                $(".outlets__list-item").each(function() {
                    $(this).show();
                    const numberOfVisibleElements = $(this).find(
                        "li:not([style='display: none;'])"
                    ).length;
                    const numberOfAllElements = $(this).data("number-of-items");
                    if (
                        numberOfAllElements - numberOfVisibleElements ===
                        numberOfAllElements
                    ) {
                        $(this).hide();
                    }
                });

                $(".outlets__loader").hide();
            }, 1000);
        });

        $("#city").on("change", function() {
            region_points = [];

            const brandChoosenCollection = $("#js-select-brands").data("value");

            for (i in points) {
                if (points[i]["city"] == $(this).val()) {
                    if (brandChoosenCollection.length) {
                        if (
                            brandChoosenCollection.some(function(brand) {
                                return (
                                    points[i]["brand_name"].indexOf(brand) >= 0
                                );
                            })
                        ) {
                            region_points.push(points[i]);
                        }
                    } else {
                        region_points.push(points[i]);
                    }
                }
            }

            set_points(region_points);
            markerCluster = new MarkerClusterer(myMap, allMarkers, {
                gridSize: 30,
                maxZoom: 8,
                styles: [cluster_options]
            });
            $(
                ".container-map-list .region-title, .container-map-list .city-title, .container-map-list .store-list"
            ).hide();
            $(".city_" + $(this).val()).show();
        });

        $(city).chosen(filter_prams);

        $("#region").on("change", function(evt, params) {
            var region_value;

            try {
                region_value = params.selected;
            } catch (error) {
                region_value = $("#region").val();
            }

            // city.disabled = true;
            // $(".chosen-select").val('').trigger("chosen:updated")

            $("#city")
                .html("")
                .prop("disabled", true)
                .trigger("chosen:updated");

            if (
                region_value === "all" &&
                allDefaultMarker.length !== allMarkers.length
            ) {
                allMarkers = allDefaultMarker.slice(0);
                setMapOnAll(myMap);
                markerCluster.addMarkers(allMarkers);

                myMap.setCenter({ lat: 50.4501, lng: 30.5234 });
                myMap.setZoom(5);
            } else {
                $.ajax({
                    method: "get",
                    url: "/change_region",
                    dataType: "json",
                    data: { region: $(this).val() },
                    success: function(data) {
                        $("#city").append('<option value=""></option>');
                        for (i in data) {
                            $("#city").append(
                                '<option value="' +
                                    data[i]["id"] +
                                    '">' +
                                    data[i]["name"] +
                                    "</option>"
                            );
                        }
                        $("#city").prop("disabled", false);
                        $("#city").trigger("chosen:updated");
                    }
                });
            }
        });

        // region_chosen
        if (!document.getElementById("region_chosen")) {
            $("#region").val("all");
        }
    }

    document.addEventListener("DOMContentLoaded", init);
})(jQuery);
